import AddToList from '@/components/AddToList';
import Loader from '@/components/Loader';
import { EntityType } from '@/models/EntityTypes';
import { resetNavigationToSetScreen } from '@/services/UtilService';
import { ApplicationState } from '@/store';
import { getListClear, getListRequest } from '@/store/list/action';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';

const AddItemToList: React.FC = () => {
    const history = useHistory();
    const dispatch = useDispatch();

    const { id } = useParams<{ id: string }>();
    const list = useSelector((state: ApplicationState) => state.lists.list);
    const loading = useSelector((state: ApplicationState) => state.lists.loading);
    const isAdmin = useSelector((state: ApplicationState) => state.identity.data.user.admin);

    useEffect(() => {
        resetNavigationToSetScreen(EntityType.LIST, list?.organizationId, isAdmin, history);
    }, [list?.organizationId, isAdmin]);

    useEffect(() => {
        dispatch(getListRequest(Number(id)));

        return () => {
            dispatch(getListClear());
        };
    }, []);

    const handleOnBackClick = () => {
        history.goBack();
    };

    return (
        <>
            {!list && loading && <Loader />}
            {list && <AddToList handleBack={handleOnBackClick} list={list} />}
        </>
    );
};

export default AddItemToList;
